import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store';
import { environment } from 'src/environments/environment';
import { CardType } from '../../../enums/card-type.enum';
import { Currency } from '../../../enums/currency.enum';
import { Balance } from '../../../models/balance.model';
import { Navigation } from '../../../models/navigation.model';
import * as fromAccountActions from '../../../store/actions/accounts/accounts.actions';

@Component({
  selector: 'lns-standard-account',
  templateUrl: './standard-account.component.html',
  styleUrls: ['./standard-account.component.scss']
})
export class StandardAccountComponent implements OnInit {
  @Input() navigations: Navigation[] = [];
  @Input() accountData!: any;
  @Input() child!: any;
  @Input() index!: any;
  @Input() homeAccount = false;
  @ViewChild('labels') labels: any;
  url!: string;
  selectedCreditTab = 0;
  selectedSavingsTab = 0;
  environment = environment;
  monthNames = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC'
  ];
  lastFourMonths: string[] = [];
  cardType = CardType;
  currency = Currency;

  constructor(private store: Store<AppState>, private router: Router) {}

  ngOnInit(): void {
    this.url = this.router.url;
    if (environment.sme) {
      this.getLastFourMonths();
    }
  }

  getLastFourMonths(): void {
    for (let i = 0; i < 4; i++) {
      let today = new Date();
      today.setDate(1);
      today.setMonth(today.getMonth() - i);
      this.lastFourMonths.unshift(this.monthNames[today.getMonth()]);
    }
  }

  changeCurrency(balance: Balance): void {
    this.accountData = { ...this.accountData, activeBalance: balance };

    if (
      this.accountData.accountType.includes('SAVINGS_ACCOUNT') ||
      this.accountData.accountType.includes('SAVINGS_PROXY_ACCOUNT') ||
      this.accountData.accountType.includes('GRADUAL_SAVINGS_ACCOUNT') ||
      this.accountData.accountType.includes('GRADUAL_SAVINGS_PROXY_ACCOUNT')
    ) {
      this.store.dispatch(
        fromAccountActions.changeSavingActiveCurrency({
          accountId: this.accountData.accountId,
          activeBalance: this.accountData.activeBalance
        })
      );
    } else if (
      this.accountData.accountType.includes('CURRENT_ACCOUNT') ||
      this.accountData.accountType.includes('CURRENT_PROXY_ACCOUNT')
    ) {
      this.store.dispatch(
        fromAccountActions.changeAccountActiveCurrency({
          accountId: this.accountData.accountId,
          activeBalance: this.accountData.activeBalance
        })
      );
    } else if (this.accountData.accountType.includes('DEPOSIT_ACCOUNT')) {
      this.store.dispatch(
        fromAccountActions.changeDepositActiveCurrency({
          accountId: this.accountData.accountId,
          activeBalance: this.accountData.activeBalance
        })
      );
    } else if (this.accountData.accountType.includes('LOAN_ACCOUNT')) {
      this.store.dispatch(
        fromAccountActions.changeLoanActiveCurrency({
          accountId: this.accountData.accountId,
          activeBalance: this.accountData.activeBalance
        })
      );
    }
  }

  navigateToAccountDetails(): void {
    if (this.homeAccount) {
      if (
        this.accountData.accountType.includes('CURRENT_ACCOUNT') ||
        this.accountData.accountType.includes('CURRENT_PROXY_ACCOUNT')
      ) {
        this.store.dispatch(
          fromAccountActions.standardAccountSelectActiveAccount({
            selectedAccount: this.accountData
          })
        );
        this.router.navigateByUrl('/accounts/(details:details)');
      } else if (this.accountData.accountType.includes('LOAN_ACCOUNT')) {
        this.store.dispatch(
          fromAccountActions.standardAccountSelectActiveLoan({
            selectedLoan: this.accountData
          })
        );
        this.router.navigateByUrl('/loans/(details:details)');
      } else if (
        this.accountData.accountType.includes('SAVINGS_ACCOUNT') ||
        this.accountData.accountType.includes('SAVINGS_PROXY_ACCOUNT') ||
        this.accountData.accountType.includes('GRADUAL_SAVINGS_ACCOUNT') ||
        this.accountData.accountType.includes('GRADUAL_SAVINGS_PROXY_ACCOUNT')
      ) {
        this.store.dispatch(
          fromAccountActions.standardAccountSelectActiveSaving({
            selectedSaving: this.accountData
          })
        );
        this.router.navigateByUrl('/savings/(details:details)');
      } else if (this.accountData.accountType.includes('DEPOSIT_ACCOUNT')) {
        this.store.dispatch(
          fromAccountActions.standardAccountSelectActiveDeposit({
            selectedDeposit: this.accountData
          })
        );
        this.router.navigateByUrl('/deposits/(details:details)');
      }
    }
  }

  navigateToAccountTransactionHistory(): void {
    if (this.homeAccount) {
      this.store.dispatch(
        fromAccountActions.standardAccountSelectActiveAccount({
          selectedAccount: this.accountData
        })
      );
      this.router.navigateByUrl('/accounts/(details:transactions)');
    }
  }

  setTotalBalanceActive(balance: Balance | undefined): void {
    this.accountData.activeBalance = balance;
  }

  onLabelsScroll(event: any): void {
    this.labels.nativeElement.scrollLeft = event.deltaY;
  }

  changeCredit(index: number) {
    this.selectedCreditTab = index;
  }

  changeSavings(index: number) {
    this.selectedSavingsTab = index;
  }
}
